import { CustomLink } from "data/types";
import React, { FC } from "react";
import { Link } from "react-router-dom";
import twFocusClass from "utils/twFocusClass";


interface PaginationControlProps {
  pages?: number;
  currentPage: number;
  pageLimit: number;
  goToNextPage?: () => void;
  goToPreviousPage?: () => void;
  changePage: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const DEMO_PAGINATION: CustomLink[] = [
  {
    label: "1",
    href: "#",
  },
  {
    label: "2",
    href: "#",
  },
  {
    label: "3",
    href: "#",
  },
  {
    label: "4",
    href: "#",
  },
];

export interface PaginationProps {
  pages: number;
  currentPage: number;
  changePage: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

const Pagination: FC<PaginationProps> = ({ className = "",pages,currentPage,changePage }) => {

  const getPaginationGroup = () => {
    let start = Math.floor((currentPage - 1) / pages) * pages;
    return new Array(pages).fill(0).map((_, idx) => start + idx + 1);
  };

  const renderItem = (value: number, index: number, array: number[]) => {
    if (index + 1 === currentPage) {
      // RETURN ACTIVE PAGINATION
      return (
        <span
          key={index}
          className={`inline-flex w-11 h-11 items-center justify-center text-neutral-400 rounded-full bg-primary-600 text-white ${twFocusClass()}`}
        >
          {value}
        </span>
      );
    }
    // RETURN UNACTIVE PAGINATION
    return (
      <button
        onClick={changePage}
        key={index}
        className={`inline-flex w-11 h-11 items-center justify-center rounded-full bg-white hover:bg-neutral-100 border border-neutral-200 text-neutral-6000 dark:text-neutral-400 dark:bg-neutral-900 dark:hover:bg-neutral-800 dark:border-neutral-700 ${twFocusClass()}`}
      >
        {value}
      </button>
    );
  };

  return (
    <nav
      className={`nc-Pagination inline-flex space-x-1 text-base font-medium ${className}`}
    >
      {getPaginationGroup().map(renderItem)}
    </nav>
  );
};

export default Pagination;
